import React from 'react'
import { goTo } from 'route-history'
import { ErrorPage } from '@gismart/ui.library/core/components'
import { ServerErrorCode } from '@gismart/ui.library/core/constants'

export const NotFound: React.FC = () => (
  <ErrorPage statusCode={ServerErrorCode.NOT_FOUND} onClick={() => goTo('/')} />
)
